<template>
  <div class="forms">
    <div class="h2">
      <a-radio-group v-model="kType" @change="resh">
        <a-radio-button :value="0">即将逾期({{ top.futureCount }})</a-radio-button>
        <a-radio-button :value="1">已逾期({{ top.overdueCount }})</a-radio-button>
      </a-radio-group>
    </div>
    <div class="table">
      <Table :getUrl='putData.url[kType]' :formKey='putData.formKey' ID='id' ref='table'
        v-if='$common.AUTH("welcome:loan")'>
        <template v-slot:pick='v'>
          <span>
            <router-link class="curpoter" :to="{ 'name': 'paybacksee', params: { id: v.id } }" target="_blank"
              style='color: #1d8bfe;'> 查看</router-link>
          </span>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
export default {
  name: 'Payback',
  props: {
    putData: Object
  },
  data() {
    return {
      kType: 0,
    }
  },
  computed: {
    top() {
      return this.$store.state.Home.Top
    },
  },
  methods: {
    resh() {
      setTimeout(e => {
        this.$refs.table.resh()
      }, 200)
    }
  },
  components: { Table }
}
</script>
<style lang="less" scoped></style>